import { TRootState } from "Redux/Reducers";

export const getInvoice = (id: string) => (state: TRootState) => state.invoice.entries[id];
